import * as types from './action_types'
import * as type from '../action_types'

const initialState = {
  loader: true,
  error: false,
  showModal: false,
  dispatchBranches: [],
  dispatchSelectVehicle: [],
  listData: [],
  receive: [],
  shortReceive: [],
  receiveItemList: [],

  //All States Of Receive Page
  receiveDispatchCities: [],
  receiveDispatchCitiestwo: [],
  receiveSelectVehicle: [],
  receiveChallanNo: [],
  receiveLastReceivePrint: [],
  branchreceiveLastReceivePrint: [],
  receiveListData: [],
  receiveReceive: [],
  receiveDataList: [],
  LrLists: [],
  LuggageData: [],
}

const BranchTransferReceiveReducer = function (state = initialState, action) {
  switch (action.type) {
    case type.LOADER:
      return {
        ...state,
        loader: action.data,
      }
    case types.DISPATCH_FROM_BRANCH:
      return {
        ...state,
        dispatchBranches: action.data,
      }
    case types.Dispatch_SELECT_VEHICLE:
      return {
        ...state,
        dispatchSelectVehicle: action.data,
      }
    case types.Dispatch_SHOWLIST_DATA:
      return {
        ...state,
        listData: action.data,
      }
    case types.Dispatch_RECEIVE:
      return {
        ...state,
        receive: action.data,
      }
    case types.Dispatch_SHORT_RECEIVE:
      return {
        ...state,
        shortReceive: action.data,
      }
    case types.Dispatch_RECEIVE_ITEMLIST:
      return {
        ...state,
        receiveItemList: action.data,
      }
    case types.RECEIVE_DISPATCH_FROM_CITY:
      return {
        ...state,
        receiveDispatchCities: action.data,
      }
    case types.RECEIVE_DISPATCH_SELECT_VEHICLE:
      return {
        ...state,
        receiveSelectVehicle: action.data,
      }
    case types.RECEIVE_DISPATCH_LOAD_VEHICLE:
      return {
        ...state,
        receiveSelectVehicle: action.data,
      }
    case types.RECEIVE_DISPATCH_CHALLAN_NO:
      return {
        ...state,
        receiveChallanNo: action.data,
      }
    case types.RECEIVE_LASTRECEIVE_PRINT:
      return {
        ...state,
        receiveLastReceivePrint: action.data,
      }
    case types.BRANCHRECEIVE_LASTRECEIVE_PRINT:
      return {
        ...state,
        branchreceiveLastReceivePrint: action.data,
      }
    case types.DISPATCH_RECEIVE_SHOWLIST_DATA:
      return {
        ...state,
        receiveListData: action.data,
      }
    case types.Dispatch_RECEIVE_RECEIVE:
      return {
        ...state,
        receiveReceive: action.data,
      }
    case types.Dispatch_RECEIVE_DATALIST:
      return {
        ...state,
        receiveDataList: action.data,
      }
    case types.Dispatch_RECEIVE_LRLIST:
      return {
        ...state,
        LrLists: action.data,
      }
    case types.Dispatch_RECEIVE_LUGGAGETORECEIVE:
      return {
        ...state,
        LuggageData: action.data,
      }
    case types.Dispatch_RECEIVE_SECOND:
      return {
        ...state,
        receiveSecond: action.data,
      }
    default:
      return state
  }
}
export default BranchTransferReceiveReducer
